import { gql } from '@apollo/client';

// binderId is set only when a single binder is expanded. The body is the
// organization ids, one when a binder is specified and every organization
// when loading all assignments.
export const assignmentsQuery = (binderId?: string) =>
  binderId ? `?binderId=${encodeURIComponent(binderId)}` : '';

export const GET_USER_ASSIGNMENTS = gql`
  query getUserAssignments($userId: String!, $body: Body!, $query: String!) {
    getUserAssignments(userId: $userId, body: $body, query: $query)
      @rest(
        type: "UserAssignmentsByOrganization"
        method: "POST"
        path: "/users/{args.userId}/assignments{args.query}"
        endpoint: "adminAssignments"
        bodyKey: "body"
      ) {
      byOrganization {
        organizationId
        assignments {
          domain
          resourceId
          resourceName
          dueDate
          dueDateKind
          status {
            code
            label
            nativeCode
          }
          responsibility {
            code
            label
          }
          binder {
            id
            name
          }
        }
      }
    }
  }
`;

export type {
  AssignmentResponsibility,
  AssignmentsTarget,
  AssignmentStatus,
  BinderReference,
  UserAssignment,
  UserAssignmentsByOrganizationResponse,
  UserAssignmentsForOrganization,
  UserAssignmentsResponse
} from './userResourceAccess.types';
